module.exports = __webpack_public_path__ + "img/world-map.a1844884.png";